"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasKeychainBeenUsed = exports.isKeychainInstalled = exports.keychain = void 0; // TODO: Add better typing

/* interface IRequestTransfer extends KeychainFunction {
  0: 'requestHandshake'
  1: {
    from: string
    to: string
    amount: number
    symbol: AssetSymbol
    memo?: string
  }
} */

/**
 *
 * @param window Window object of your browser
 * @param fn Keychain function name
 * @param args Function arguments
 *
 * Example 1: keychain(window, 'requestTransfer', sender, receiver, amount, memo, asset)
 *
 * Example 2: keychain(window, 'requestTransfer', 'test', 'therealwolf', 5, 'test memo', 'HIVE')
 *
 * More info: https://github.com/stoodkev/hive-keychain
 *
 * Return Object:
 * success => whether it was successfully transferred
 *
 * msg => error message
 *
 * cancel => keychain popup was cancelled by the user
 *
 * notInstalled => keychain is not yet installed
 *
 * notActive => keychain was used before but is not active right now and
 * has to either be clicked on or set to allow current page
 */

var keychain = function keychain(window, fn) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$exports$isKeyc, installed, used;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return exports.isKeychainInstalled(window);

          case 3:
            _yield$exports$isKeyc = _context.sent;
            installed = _yield$exports$isKeyc.installed;
            used = _yield$exports$isKeyc.used;

            if (installed) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", {
              success: false,
              msg: '',
              notInstalled: !installed,
              notActive: used,
              cancel: false
            });

          case 8:
            return _context.abrupt("return", new Promise(function (resolve) {
              var _window$hive_keychain;

              (_window$hive_keychain = window.hive_keychain)[fn].apply(_window$hive_keychain, args.concat([function (r) {
                if (r.error === 'user_cancel') {
                  return resolve(Object.assign({
                    success: false,
                    msg: r.error,
                    cancel: true
                  }, r));
                }

                if (r.success) {
                  return resolve(Object.assign({
                    success: true,
                    msg: r.result
                  }, r));
                }

                return resolve(Object.assign({
                  success: false,
                  msg: r.message
                }, r));
              }]));
            }));

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", {
              success: false,
              msg: _context.t0.message
            });

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 11]]);
  }));
};

exports.keychain = keychain;

var isKeychainInstalled = function isKeychainInstalled(window) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var used;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            used = exports.hasKeychainBeenUsed();

            if (window.hive_keychain) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", {
              installed: false,
              used: used
            });

          case 3:
            _context2.prev = 3;
            _context2.next = 6;
            return function () {
              return new Promise(function (resolve) {
                window.hive_keychain.requestHandshake(function (r) {
                  if (r.error) {
                    throw new Error('missing');
                  } else {
                    resolve(true);
                  }
                });
              });
            };

          case 6:
            _context2.next = 11;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](3);
            return _context2.abrupt("return", {
              installed: false,
              used: used
            });

          case 11:
            if (!exports.hasKeychainBeenUsed()) localStorage.setItem('hasKeychain', 'true');
            return _context2.abrupt("return", {
              installed: true,
              used: true
            });

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 8]]);
  }));
};

exports.isKeychainInstalled = isKeychainInstalled;

var hasKeychainBeenUsed = function hasKeychainBeenUsed() {
  return Boolean(localStorage.getItem('hasKeychain'));
};

exports.hasKeychainBeenUsed = hasKeychainBeenUsed;